// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"131": "12661327b046a3b5","339": "6dc8d0f4f517ea8f","84": "4c7e65f6327f05ac",}[chunkId] + ".css"
}